<template>
  <div class="default-modal">
    <div class="modal-cover animated fadeIn faster" @click="cancel"></div>
    <div class="modal animated fadeIn faster">
      <div v-if="modal.showTitle" class="modal-header">
        <h5 class="modal-title">{{modal.title}}</h5>
      </div>
      <div class="modal-body">
        <slot></slot>
      </div>
      <div v-if="modal.showCancelBtn || modal.showConfirmBtn" class="modal-footer">
        <button
          v-if="modal.showCancelBtn"
          type="button"
          :class="'btn btn-cancel '+ modal.cancelBtnClass"
          @click="cancel"
        >
          {{modal.cancelBtnText}}
        </button>
        <button
          v-if="modal.showConfirmBtn"
          type="button"
          :class="'btn btn-confirm '+ modal.confirmBtnClass"
          @click="confirm"
        >
          {{modal.confirmBtnText}}
        </button>
      </div>
      <div class="iconfont icon-close close-btn" @click="cancel"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DefaultModal',
  props: ['modalOptions'],
  data () {
    return {
    }
  },
  computed: {
    modal: {
      get () {
        let modal = this.modalOptions
        modal = {
          showTitle: this._.isNil(modal.showTitle) ? true : modal.showTitle,
          title: modal.title || '提示',
          showCancelBtn: this._.isNil(modal.showCancelBtn) ? true : modal.showCancelBtn,
          cancelBtnClass: modal.cancelBtnClass ? modal.cancelBtnClass : 'btn-blue btn-outline',
          cancelBtnText: modal.cancelBtnText ? modal.cancelBtnText : '取消',
          showConfirmBtn: this._.isNil(modal.showConfirmBtn) ? true : modal.showConfirmBtn,
          confirmBtnClass: modal.confirmBtnClass ? modal.confirmBtnClass : 'btn-blue',
          confirmBtnText: modal.confirmBtnText ? modal.confirmBtnText : '确定',
        }
        return modal
      }
    }
  },
  methods: {
    confirm () {
      this.$emit('confirm')
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.default-modal {
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  outline: 0;
  .modal-cover {
    position: fixed;
    z-index: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(#000, .7);
  }
  .modal {
    position: absolute;
    z-index: 1;
    @include center();
    border-radius: 7px;
    background: linear-gradient(180deg, rgba(0, 40, 108, 0) 0%, #00286c 100%), #ef2ac1;
    overflow: hidden;
  }
  .modal-header {
    text-align: center;
    font-size: $font-lg-s;
    font-weight: bold;
  }
  .modal-body {
    @include display-flex;
    width: 170px;
    min-height: 170px;
    align-items: center;
    @include respond-to(desktop) {
      width: 310px;
      min-height: 310px;
    }
  }
  .modal-footer {
    padding: 10px;
    margin-top: 60px;
    text-align: center;
    @include respond-to(mobile) {
      @include display-flex;
      padding: 0;
    }
    .btn {
      display: inline-block;
      margin: 0 5px;
      text-align: center;
      &.btn-confirm {
        width: 120px;
      }
      @include respond-to(mobile) {
        @include flex(1);
        display: block;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding: 0;
        margin: 0;
        border: none;
        border-right: 1px solid #cbcbcb;
        border-radius: 0;
        font-size: $font-nm-l;
        &:last-child {
          border-right: none;
        }
      }
    }
  }
  .close-btn {
    position: absolute;
    z-index: 10;
    top: 4px;
    right: 4px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DefaultModal.vue